// extracted by mini-css-extract-plugin
export default {"container":"MobileScan_container__UwRlP","floatingButton":"MobileScan_floatingButton__cMe2r"};